import React, { useState, useEffect } from "react";
import {Container ,Input, Form} from "reactstrap";
import { useFormik } from "formik";
import { Loading } from "../../share/loading";
import * as Yup from "yup";
// import { NumberWithCommas } from "../../share/NumberWithCommas";
// import { FormatDate } from "../../share/FormatDate";


export function DuplicateRecoveryInformationComponent () {
    const [loading, setLoading] = useState(false);
    const [employeeForSelect, setEmployeeForSelect] = useState([]);
    const [selectEmployee, setSelectEmployee] = useState([])
    const [detailSelectEmployee, setDetailSelectEmployee] = useState([]);

    const fromInitialValues = {
        selectEmployee:""
    }
    const validateSchema = Yup.object().shape({
        selectEmployee:Yup.string().required("กรุณาเลือก")
    })

    const formik = useFormik({
        initialValues:fromInitialValues,
        validationSchema: validateSchema
    })


    useEffect(()=> {
        async function getSelectBorrowId () {
            setLoading(true)
            try{
                let res = await fetch(`api/ProposalBorrow/getDuplicateDataByBorrowId`);
                let resJson = await res.json();
                setEmployeeForSelect(resJson.dataenum);

            } catch (e) {
                console.log("err => ",e)
            } finally {
                setLoading(false)
            }
        }
        getSelectBorrowId()
    },[])

    useEffect(()=> {
        async function getDetailByBorrowId () {
            setLoading(true)
            try{
                let res = await fetch(`api/ProposalBorrow/getDetailDuplicateDataByBorrowId/${selectEmployee}`);
                let resJson = await res.json();
                console.log(resJson.dataenum);
                setDetailSelectEmployee(resJson.dataenum);
            } catch (e) {
                console.log("err =>",e)

            } finally {
                setLoading(false)
            }
        }
        getDetailByBorrowId()
        
    },[selectEmployee])

    return(
        <Container>
        {!loading ? (
          <>
            <div className="d-flex flex-column justify-content-center align-items-center mb-2">
              <Form 
                className="d-flex align-items-center justify-content-center w-100"
                onSubmit={formik.handleSubmit}
                autoComplete="off"
                >
                <div className="d-flex align-items-center justify-content-center w-50 mx-1">
                  <span className="w-75 text-center">กรุณาเลือกสถานประกอบการ</span>
                    <Input
                        name="selectEmployee"
                        type="select"
                        className="text-center w-100 input-color rounded-pill"
                        onChange={(e)=> {
                            formik.handleChange(e)
                            setSelectEmployee(e.target.value)
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.selectEmployee}
                        >
                        <option defaultValue={"กรุณาเลือก"}>
                            กรุณาเลือก
                        </option>
                        {/* {employeeForSelect.map((employee,i) => (
                            <option key={i} value = {employee.borrowId}>
                                {employee.employee}
                            </option>
                        ))} */}
                    </Input>  
                </div>
              </Form>
            </div>
            <div className="d-flex justify-content-center">
                <div className="form-border">
                    {detailSelectEmployee?.map((data,i) =>(
                        <div key={i}>
                            ข้อมูลการขอกู้ครั้งที่ {data.rowNumber}
                            {/* <p>ทำสัญญาวันที่ {FormatDate(data.contactDate)} </p> */}
                            
                        </div>
                    ))}


                </div>
            </div>
            
            
           
          </>
        ):(<Loading/>)}
        
        </Container>
    )
}